module.exports = __webpack_public_path__ + "img/grey-star.d6a7fb82.svg";